import { render, staticRenderFns } from "./JobEdit.vue?vue&type=template&id=f2fa8664&scoped=true&"
import script from "./JobEdit.vue?vue&type=script&lang=js&"
export * from "./JobEdit.vue?vue&type=script&lang=js&"
import style0 from "./JobEdit.vue?vue&type=style&index=0&id=f2fa8664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fa8664",
  null
  
)

export default component.exports